<template>
    <div class="flex flex-row gap-4 items-center text-5xl">
        <WarningIcon class="size-12 text-red-700" />
        <span class="font-light text-red-700">{{ $t('scenario-not-found') }}</span>
    </div>
</template>

<script setup lang="ts">
import WarningIcon from '../Icon/WarningIcon.vue';
</script>
